
import { Pipe, PipeTransform } from '@angular/core';
import { NotifiableContactEntity } from '@jms/model';

@Pipe({
    name: 'smsContacts',
    standalone: true
})
export class ActivitySmsContactsPipe implements PipeTransform {

    transform(
        value: NotifiableContactEntity[]
    ): string {

        if (!value) {
            return '';
        }

        return value
            .map(contact => `${contact.name} <${contact.mobile}>`)
            .join(', ');

    }
}